import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';

export interface SolicitarCotacaoFornecedor {
  idCotacaoFornecedor: number;
  nome: string;
  email: string | null;
  /** O cadastro do fornecedor não pôde ser lido — diferente de estar sem e-mail. */
  cadastroIndisponivel?: boolean;
  /** Já recebeu, mas o link foi desativado porque os produtos mudaram: o envio gera um link novo. */
  reenvio?: boolean;
}

export interface SolicitarCotacaoDialogData {
  fornecedores: SolicitarCotacaoFornecedor[];
}

/**
 * Confirmação do envio do formulário de cotação. Abre depois de salvar o
 * card, sugerindo os fornecedores que ainda não receberam — todos marcados, para o caso
 * comum ser um clique. Fornecedor sem e-mail aparece na lista, mas não pode ser marcado:
 * é a única forma de o comprador descobrir que falta o cadastro. Quando o cadastro não pôde
 * ser lido, o aviso diz isso em vez de acusar falta de e-mail.
 */
@Component({
  selector: 'app-solicitar-cotacao-dialog',
  standalone: true,
  imports: [MatDialogModule, MatButtonModule, MatCheckboxModule, MatIconModule, MatTooltipModule],
  templateUrl: './solicitar-cotacao-dialog.component.html',
  styleUrl: './solicitar-cotacao-dialog.component.css',
})
export class SolicitarCotacaoDialogComponent {
  public readonly selecionados = new Set<number>();

  constructor(
    public dialogRef: MatDialogRef<SolicitarCotacaoDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: SolicitarCotacaoDialogData,
  ) {
    data.fornecedores
      .filter(f => !!f.email)
      .forEach(f => this.selecionados.add(f.idCotacaoFornecedor));
  }

  public get temReenvio(): boolean {
    return this.data.fornecedores.some(f => f.reenvio);
  }

  public alternar(fornecedor: SolicitarCotacaoFornecedor): void {
    if (this.selecionados.has(fornecedor.idCotacaoFornecedor)) {
      this.selecionados.delete(fornecedor.idCotacaoFornecedor);
      return;
    }
    this.selecionados.add(fornecedor.idCotacaoFornecedor);
  }

  public confirmar(): void {
    if (!this.selecionados.size) return;
    this.dialogRef.close([...this.selecionados]);
  }

  public fechar(): void {
    this.dialogRef.close();
  }
}
